import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../css/calculationProcessCSS/startPage.module.css";

function StartPage() {
  const navigate = useNavigate();
  const [currentVideo, setCurrentVideo] = useState(0);

  const videos = [
    "https://www.youtube.com/embed/PjUQtDEjQKA",
    "https://www.youtube.com/embed/YqWBnhZ8kxI",
  ];

  const link = (e) => {
    if (e) {
      e.preventDefault();
    }
    navigate("/intro");
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentVideo((prevVideo) => (prevVideo + 1) % videos.length);
    }, 15000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.containerWrap}>
        <div className={styles.contents}>
          <div className={styles.videoContents}>
            <div
              className={styles.videoPlay}
              style={{
                position: "relative",
                paddingTop: "177.77%",
                width: "100%",
                overflow: "hidden",
              }}
            >
              <iframe
                style={{
                  position: "absolute",
                  top: "-60px",
                  left: "-1px",
                  width: "calc(100% + 2px)",
                  height: "calc(100% + 120px)",
                  border: "none",
                }}
                src={`${
                  videos[currentVideo]
                }?autoplay=1&mute=1&controls=0&loop=1&playlist=${videos[
                  currentVideo
                ]
                  .split("/")
                  .pop()}&modestbranding=1&rel=0&showinfo=0`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
                onClick={link}
              />
              <div className={styles.SVG} onClick={link}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="121"
                  height="121"
                  viewBox="0 0 121 121"
                  fill="none"
                >
                  <g
                    clipPath="url(#clip0_10_1027)"
                    filter="url(#filter0_d_10_1027)"
                  >
                    <path
                      d="M85.8664 44.1027C79.7336 42.2805 73.0641 42.4618 67.1606 44.4589C64.4653 45.1682 61.8922 46.0893 59.4413 47.2221C61.3354 36.8139 54.1658 26.8402 43.7577 24.9461C33.3495 23.052 23.3759 30.2216 21.4817 40.6297C19.5876 51.0379 26.7572 61.0115 37.1654 62.9057C39.0467 63.2308 40.8057 63.3443 42.3203 63.0343L45.0092 67.6916L39.7888 66.4717C35.1139 65.2191 30.2449 68.0302 28.7806 72.8273C27.528 77.5021 30.0052 82.2817 34.68 83.5343L51.018 89.3436C53.1525 92.0629 55.7999 94.2038 58.7484 95.8886C60.9069 97.1827 63.4887 98.2324 65.8262 98.8587L68.1484 102.881C68.8817 104.151 70.2174 104.509 71.4876 103.776L100.278 87.1534C101.337 86.5423 101.784 84.8727 101.173 83.8143L97.995 78.3102C99.2061 71.119 97.7786 63.7576 94.2342 57.6185L87.1453 45.3401C86.8681 44.3711 86.412 44.07 85.8664 44.1027ZM27.8046 51.0923C23.7712 44.1063 26.3092 35.3023 33.4174 31.4806C40.4033 27.4473 49.2074 29.9853 53.029 37.0934C55.229 40.9039 55.491 45.2688 53.8717 49.3086L47.7606 38.7239C46.5933 36.9517 44.7923 35.6931 42.7268 35.2062C40.6613 34.7193 38.4878 35.0409 36.6519 36.1052C32.7191 38.0935 31.1654 43.2245 33.3654 47.035L39.7209 58.0431C34.8999 58.0039 30.4607 55.2039 27.8046 51.0923ZM90.0898 59.729C93.4792 65.1108 94.6296 71.5032 93.4752 77.8149C93.2962 78.4827 93.1173 79.1506 93.484 79.7856L96.0506 84.2312L71.494 98.409L69.7829 95.4453C69.4162 94.8102 68.6262 94.4196 67.9583 94.2406C65.7431 93.826 63.6174 93.0775 61.4589 91.7833C58.9665 90.3997 56.6531 88.3483 54.763 86.0524C54.5186 85.629 54.0624 85.3278 53.6063 85.0266L36.4783 78.8267C35.4765 78.5583 34.5642 77.9559 33.9531 76.8975C33.4642 76.0507 33.2765 74.7477 33.5449 73.746C34.2935 71.6203 36.4104 70.3981 38.6256 70.8127L48.3092 73.4074L51.9759 79.7582L54.7759 75.3191L37.1759 44.835C36.532 43.2309 37.0688 41.2274 38.8846 40.4613C40.3665 39.6057 42.4595 39.8087 43.315 41.2905L57.3706 65.6355L62.0934 64.0378L56.4711 54.2998C56.5606 53.9659 56.7723 53.8437 56.8618 53.5098C58.3437 52.6542 59.9477 52.0103 61.5518 51.3665L67.7852 62.1629L71.539 60.8425L65.1834 49.8343L68.0904 49.0027C69.2711 48.6033 70.574 48.4156 71.8769 48.2279L77.9881 58.8126L81.7418 57.4922L76.1196 47.7542C78.5138 47.501 80.9407 47.7934 83.2781 48.4197L90.0898 59.729Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_10_1027"
                      x="-4"
                      y="0"
                      width="128.21"
                      height="128.21"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_10_1027"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_10_1027"
                        result="shape"
                      />
                    </filter>
                    <clipPath id="clip0_10_1027">
                      <rect
                        width="88"
                        height="88"
                        fill="white"
                        transform="translate(0 44) rotate(-30)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StartPage;
